"use client";

import { c as _c } from "react/compiler-runtime";
import { ThemeProvider } from "next-themes";
export function Theme(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      light: "light-mode",
      dark: "dark-mode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <ThemeProvider attribute="class" value={t1} enableSystem={true}>{children}</ThemeProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}